// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"88777865","302":"feab3b81","307":"0110acb0","564":"56ec7ed5","845":"6abe21e3","909":"f91be58d"}[chunkId] + ".chunk.js";
};